export default __webpack_public_path__ + "static/media/analyseLogo.3054bdd0.png";